import { render, staticRenderFns } from "./ShipmentEdit.vue?vue&type=template&id=2fdeebe1&"
import script from "./ShipmentEdit.vue?vue&type=script&lang=js&"
export * from "./ShipmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShipmentEdit.vue"
export default component.exports